export default function guest({ next, to, store }) {
  const loggedInStatus = store.getters['auth/loggedInStatus']
  if (loggedInStatus) {
    location.replace('/')
  } else {
    return next()
  }
}
